export default "__VITE_ASSET__COoXzYe1__"